"use client";

import { ReactNode } from "react";
import { Button } from "./button";
import { Inbox } from "lucide-react";

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  className?: string;
}

export function EmptyState({ icon, title, description, action, className = "" }: EmptyStateProps) {
  return (
    <div className={`flex flex-col items-center justify-center rounded-xl border border-dashed border-[var(--color-border-strong)] bg-[var(--color-surface)] px-4 py-12 text-center shadow-[var(--shadow-xs)] ${className}`}>
      <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-[var(--color-accent-soft)] text-[var(--color-accent-strong)]">
        {icon ?? <Inbox className="h-5 w-5" aria-hidden="true" />}
      </div>
      <h3 className="mt-4 font-[family-name:var(--font-display)] text-xl font-semibold text-[var(--color-text)]">{title}</h3>
      <p className="mt-1.5 max-w-sm text-sm leading-relaxed text-[var(--color-text-muted)]">{description}</p>
      {action && (
        <Button onClick={action.onClick} className="mt-5">{action.label}</Button>
      )}
    </div>
  );
}
